import { ChatMode, UserChatEntry } from 'dragonmouse-shared/interfaces';
import { useDsChatQueue } from 'hooks/useDsChatQueue';
import { useSceneChatQueue } from 'hooks/useSceneChatQueue';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

export type ChoiceChatType = 'scene' | 'ds';

interface Props {
	options: Array<{ label: string }>;
	chatType: ChoiceChatType;
}

const ChoiceAction = ({ options, chatType }: Props) => {
	const { chatId, isMobile } = useSelector((r: RootReducer) => ({
		chatId: chatType === 'scene' ? r.mode.activeSceneChatId : r.mode.activeDsChatId,
		isMobile: selectIsMobile(r.mode),
	}));

	// Both hooks always called (rules of hooks). Pass null where not used.
	const dsQueue = useDsChatQueue(chatType === 'ds' ? chatId : null);
	const sceneQueue = useSceneChatQueue(chatType === 'scene' ? chatId : null);
	const items = chatType === 'ds' ? dsQueue.items : sceneQueue.items;

	if (!chatId) return null;

	const onSelect = (label: string) => {
		const clientKey = `choice:${label}`;
		if (items.some((e) => e.clientKey === clientKey)) return;

		const entry: UserChatEntry = {
			kind: 'user',
			message: label,
			sourceFrameIds: [],
			attachments: [],
		};
		if (chatType === 'scene') {
			sceneQueue.enqueue({
				label,
				clientKey,
				payload: {
					kind: 'addUserEntry',
					entry,
					chatMode: ChatMode.DESIGN_AND_CHAT,
					style: null,
				},
			});
		} else {
			dsQueue.enqueue({
				label,
				clientKey,
				payload: { kind: 'addUserEntry', entry, chatMode: ChatMode.DESIGN_AND_CHAT },
			});
		}
	};

	return (
		<S.Base>
			{options.map((opt) => {
				const clientKey = `choice:${opt.label}`;
				const isQueued = items.some((e) => e.clientKey === clientKey);
				return (
					<S.Option
						key={opt.label}
						type="button"
						isMobile={isMobile}
						$queued={isQueued}
						onClick={() => onSelect(opt.label)}
					>
						{opt.label}
					</S.Option>
				);
			})}
		</S.Base>
	);
};

export default ChoiceAction;
